import axios from "axios";
import {Result, URLSearchParamsBuilder} from "@zhoujianhui/vip-core";

const tradeCaseService = {
    baseUrl: "/trade-case",
    setBaseUrl(baseUrl) {
        this.baseUrl = baseUrl
    },
    //查询贸易案例列表
    async searchTradeCaseList(tradeCaseQuery, pageable) {
        const params = new URLSearchParamsBuilder()
            .appendObject(tradeCaseQuery)
            .appendPageable(pageable)
            .build()
        try {
            const response = await axios.get(this.baseUrl, {
                params: params
            })
            return Result.success("查询贸易案例列表成功！").data(response.data).build();
        } catch (error) {
            return Result.error("查询贸易案例列表失败！" + error.message).build();
        }
    },
    //根据id查询贸易案例明细
    async getTradeCaseById(id) {
        try {
            const response = await axios.get(this.baseUrl + "/" + id);
            return Result.success("查询贸易案例明细成功！").data(response.data).build();
        } catch (error) {
            return Result.error("查询贸易案例明细失败！" + error.message).build();
        }
    }
}

export default tradeCaseService